import logger from "../../../../utils/logger"

export class BricksRequirements {
    files
    plankWidth
    plankHeight
    textureWidth
    textureHeight
    groutLineWidth
    groutLineColor
    offset

    setFiles(files){
        // Ensure files is an array with at least one item
        if (!files || !Array.isArray(files) || files.length === 0) {
            logger.error(`[ERROR] Invalid files provided to BricksRequirements.setFiles:`, files);
            this.files = [];
        } else {
            logger.log(`[DEBUG] BricksRequirements.setFiles: Setting ${files.length} files`);
            this.files = files;
        }
        return this;
    }

    setPlankWidth(plankWidth){
        this.plankWidth = plankWidth
        return this
    }

    setPlankHeight(plankHeight){
        this.plankHeight = plankHeight
        return this
    }

    setTextureWidth(textureWidth){
        this.textureWidth = textureWidth
        return this
    }

    setTextureHeight(textureHeight){
        this.textureHeight = textureHeight
        return this
    }

    setGroutLineWidth(groutWidth){
        this.groutLineWidth = groutWidth
        return this
    }

    setGroutLineColor(color){
        this.groutLineColor = color
        return this
    }

    setOffset(offset){
        this.offset = offset
        return this
    }
}